import { ChevronRightIcon } from 'lucide-react';
import * as React from 'react';

import { DimeButton } from '../DimeButton.js';
import { cn } from '../lib/utils.js';

interface DimeNestedTableToggleProps {
  isExpanded: boolean;
  onClick: () => void;
}

export function DimeNestedTableToggle({
  isExpanded,
  onClick,
}: Readonly<DimeNestedTableToggleProps>) {
  return (
    <DimeButton
      variant="ghost"
      size="icon"
      // Excluded from the tab sequence so the parent rows' roving tabindex is the single stop for
      // the whole table; the row's onKeyDown handles Enter/Space in its place.
      tabIndex={-1}
      aria-label={`${isExpanded ? 'Collapse' : 'Expand'} row`}
      onClick={onClick}
    >
      <ChevronRightIcon className={cn('transition-transform', isExpanded && 'rotate-90')} />
    </DimeButton>
  );
}
